<!--
 * @Date: 2022-07-12 19:45:58
 * @LastEditTime: 2022-07-18 20:55:47
 * @FilePath: /vue-medweb/packages/vue-m-vaccine-prefecture/src/views/VaccineList/components/Empty.vue
 * @Description: 空状态
-->
<template>
  <div class="empty-wrap">
    <img
      src="https://staff.chunyu.mobi/@/media/images/2022/07/12/e1f4/016470faf26e_w468_h279_.png"
      alt=""
      class="icon"
    />
    <div class="desc">该商品暂时无货</div>
  </div>
</template>

<script>
export default {
  name: 'Empty',
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.empty-wrap {
  padding: rem(50) 0;
  background: #fff;
  .icon {
    display: block;
    width: rem(156);
    height: rem(120);
    margin: auto;
  }
  .desc {
    margin-top: rem(20);
    color: #666;
    font-size: rem(14);
    text-align: center;
  }
}
</style>
